<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="props.size" :background="props.background" viewBox="0 0 19 15">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.2152 1.99799C9.7285 1.99799 9.33392 2.39257 9.33392 2.87931C9.33392 3.36605 9.7285 3.76063 10.2152 3.76063H17.2658C17.7525 3.76063 18.1471 3.36605 18.1471 2.87931C18.1471 2.39257 17.7525 1.99799 17.2658 1.99799H10.2152ZM10.215 10.3705C9.72828 10.3705 9.3337 10.7651 9.3337 11.2518C9.3337 11.7386 9.72828 12.1332 10.215 12.1332H17.2656C17.7523 12.1332 18.1469 11.7386 18.1469 11.2518C18.1469 10.7651 17.7523 10.3705 17.2656 10.3705H10.215Z"
      :class="colorClass"
    />
    <path
      d="M3.07403 3.56118L6.07963 0.493309C6.42068 0.149392 6.97374 0.149388 7.31493 0.493164C7.65628 0.837099 7.65649 1.39507 7.31526 1.73912L3.6994 5.42238C3.35473 5.76943 2.79336 5.76941 2.44871 5.42234L0.776326 3.71337C0.435235 3.36945 0.435235 2.81185 0.776326 2.46793C1.11742 2.12401 1.67043 2.12401 2.01152 2.46793L3.07403 3.56118Z"
      :class="colorClass"
    />
    <path
      d="M3.07403 12.2157L6.07963 9.14786C6.42068 8.80395 6.97374 8.80394 7.31493 9.14772C7.65628 9.49165 7.65649 10.0496 7.31526 10.3937L3.6994 14.0769C3.35473 14.424 2.79336 14.424 2.44871 14.0769L0.776326 12.3679C0.435235 12.024 0.435235 11.4664 0.776326 11.1225C1.11742 10.7786 1.67043 10.7786 2.01152 11.1225L3.07403 12.2157Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
